import { FiltersMap } from '../model';
import {
  useWixPatternsContainer,
  useCollectionContext,
  useCollectionPageContext,
} from '../providers';
import {
  ExportState,
  ModalState,
  SaveAsFn,
  TransformQuery,
  CustomTotalFn,
} from '../state';
import { ReportBI } from '../services';
import { useCallback } from 'react';
import { CreateExportAsyncJobRequest } from '@wix/bex-utils/@wix/ambassador-fedinfra-exportservice-v1-export-async-job/types';

export interface UseExportParams<T, F extends FiltersMap> {
  transformPlatformizedQuery?: TransformQuery<T, F>;
  differentQueryEndpointThanCollection?: boolean;
  customTotal?: CustomTotalFn<T, F>;
  createExportAsyncJobRequest: Partial<CreateExportAsyncJobRequest>;
  reportBi: ReportBI;
  exportModalState: ModalState;
  saveAs?: SaveAsFn<T, F>;
}

export function useCreateExport<T, F extends FiltersMap>(
  params: UseExportParams<T, F>,
) {
  const collection = useCollectionContext<T, F>();
  const collectionPageState = useCollectionPageContext();

  const {
    createExportAsyncJobRequest,
    transformPlatformizedQuery,
    differentQueryEndpointThanCollection,
    customTotal,
    reportBi,
    exportModalState,
    saveAs,
  } = params;

  const {
    httpClient,
    showToast,
    translate,
    window,
    internalMonitor,
    onlineState,
    errorHandler,
  } = useWixPatternsContainer();

  return useCallback(() => {
    return new ExportState({
      transformPlatformizedQuery,
      createExportAsyncJobRequest,
      saveAs,
      httpClient,
      showToast,
      translate,
      collection,
      differentQueryEndpointThanCollection,
      customTotal,
      reportBi,
      exportModalState,
      collectionPageState,
      window,
      onlineState,
      internalMonitor,
      errorHandler,
    });
  }, []);
}
